module.exports = __webpack_public_path__ + "img/offline2.3d80b68e.svg";